import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'reactstrap';

class UploadFileProgress extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      bytesUploaded: null,
      totalSize: null,
    };

    this.onProgress = this.onProgress.bind(this);
  }

  componentDidMount() {
    const { uploader } = this.props;
    uploader.on('progress', this.onProgress);
  }

  componentWillUnmount() {
    this.unregisterEventHandlers();
  }

  onProgress(fileId, name, bytesUploaded, totalSize) {
    const { id } = this.props;
    if (fileId === id) {
      this.setState({
        bytesUploaded,
        totalSize,
      });
    }
  }

  unregisterEventHandlers() {
    const { uploader } = this.props;
    uploader.off('progress', this.onProgress);
  }

  render() {
    const {
      bytesUploaded,
      totalSize,
    } = this.state;
    const progress = (bytesUploaded / totalSize) * 100 || 0;

    return (
      <div className="uploading-file-progress">
        <Progress value={progress} />
      </div>
    );
  }
}

UploadFileProgress.propTypes = {
  id: PropTypes.number.isRequired,
  uploader: PropTypes.object.isRequired,
};

export default UploadFileProgress;
